import { CHAT_TOPIC_MESSAGES } from './actions';

export const api_call = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: CHAT_TOPIC_MESSAGES,
      payload: data,
    });
  };
};

export default api_call;
